import { render } from "./AiDistillation.vue?vue&type=template&id=a230c974&scoped=true"
import script from "./AiDistillation.vue?vue&type=script&lang=js"
export * from "./AiDistillation.vue?vue&type=script&lang=js"

import "./AiDistillation.vue?vue&type=style&index=0&id=a230c974&scoped=true&lang=scss"
import "./AiDistillation.vue?vue&type=style&index=1&id=a230c974&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a230c974"]])

export default __exports__